import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { PeoPayrollProvidersDetailCompanyInformationForm } from 'src/components/peoPayrollProvider';
import { usePeoPayrollProviderParamId } from 'src/hooks/peoPayrollProvider';

export const PeoPayrollProviderDetailCompanyInformationPage: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();

  return (
    <DetailPageLayout titleContent="Company Information">
      <PeoPayrollProvidersDetailCompanyInformationForm
        peoPayrollProviderId={peoPayrollProviderId}
      />
    </DetailPageLayout>
  );
};
